/**
 *  BLOCK: Cloudbeds
 *  ---
 *  Add Cloudbeds Booking Engine iFrame to a Page
 */

const { __ } = wp.i18n
const { registerBlockType } = wp.blocks;

import EditBlock from "./EditBlock.js"

const siteminderSVG = <svg version="1.1" class="svg-logo-default" x="0px" y="0px" viewBox="0 0 430 430">
                      <style>
                        {`.logo-path0{fill:#fff} .logo-path1{fill:#00344d} .logo-path2{fill:#008bce} .logo-path3{fill:none}`}
                      </style>
                      <g>
                      <g className="svg-logo-icon">
                      <g>
                      <path className="logo-path0" d="M217.5,425.8C101.4,425.8,7,331.4,7,215.3S101.4,4.8,217.5,4.8S428,99.3,428,215.3S333.6,425.8,217.5,425.8z"></path>
                      <path className="logo-path1" d="M217.5,8.6c27.9,0,55,5.5,80.5,16.2c24.6,10.4,46.7,25.3,65.7,44.3c19,19,33.9,41.1,44.3,65.7
                              c10.8,25.5,16.2,52.6,16.2,80.5s-5.5,55-16.2,80.5c-10.4,24.6-25.3,46.7-44.3,65.7c-19,19-41.1,33.9-65.7,44.3
                              c-25.5,10.8-52.6,16.2-80.5,16.2s-55-5.5-80.5-16.2c-24.6-10.4-46.7-25.3-65.7-44.3c-19-19-33.9-41.1-44.3-65.7
                              c-10.8-25.5-16.2-52.6-16.2-80.5s5.5-55,16.2-80.5c10.4-24.6,25.3-46.7,44.3-65.7c19-19,41.1-33.9,65.7-44.3
                              C162.5,14.1,189.6,8.6,217.5,8.6 M217.5,1C99.1,1,3.2,97,3.2,215.3s95.9,214.3,214.3,214.3s214.3-95.9,214.3-214.3
                              S335.8,1,217.5,1L217.5,1z"></path>
                      </g>
                      <g>
                      <g>
                      <path className="logo-path2" d="M222.1,284.1c-4.7,0.3-8.2,4.4-8.2,9l0,19l17.5-0.1l0-19.2C231.5,287.8,227.2,283.8,222.1,284.1z"></path>
                      <path className="logo-path2" d="M260.2,107.9c-41.1,0-76.5,24.3-92.7,59.4c-6.6-1.9-13.6-3-20.8-3c-40.9,0-74,33.1-74,74
                                c0,40.9,33.1,74,74,74h32.1l0.5,0c-5.6-4.2-9.2-10.8-9.2-18.3v-25.6c-3.9-2.3-7-5.9-8.8-10.3c-3.3-8.2-1.5-17.4,4.8-23.6
                                l41.5-41c4.1-4,9.5-6.2,15.2-6.2c5.7,0,11.1,2.2,15.2,6.2l41.5,41c6.3,6.2,8.2,15.5,4.8,23.6c-1.8,4.4-5,8-8.8,10.3v27.7
                                c0,6.3-2.8,12-7.3,15.8l0.9,0c52.3-4.5,93.3-48.3,93.3-101.8C362.3,153.7,316.6,107.9,260.2,107.9z"></path>
                      <path className="logo-path3" d="M275.4,296.1v-27.7c3.9-2.3,7-5.9,8.8-10.3c3.3-8.2,1.5-17.4-4.8-23.6l-41.5-41c-4.1-4-9.5-6.2-15.2-6.2
                                c-5.7,0-11.1,2.2-15.2,6.2l-41.5,41c-6.3,6.2-8.2,15.5-4.8,23.6c1.8,4.4,5,8,8.8,10.3V294c0,7.5,3.6,14.1,9.2,18.3l34.8-0.2
                                l0-19c0-4.7,3.5-8.7,8.2-9c5.1-0.3,9.3,3.7,9.3,8.7l0,19.2l36.7-0.2C272.6,308.1,275.4,302.4,275.4,296.1z"></path>
                      </g>
                      </g>
                      </g>
                      </g>
                      </svg>

registerBlockType('bed66-blocks/siteminder', {

    title: 'Siteminder',
  
    icon: siteminderSVG,
  
    category: 'bed66',
  
    attributes: {
      defaultURL: {
        type: 'string',
        default: 'https://assets.siteminder.com/logo/brand/siteminder-icon-reverse.svg'
      },
      tempURL: {
        type: 'string',
        default: 'https://assets.siteminder.com/logo/brand/siteminder-icon-reverse.svg'
      },
      url: {
        type: 'string',
        default: ''
      },
      widgetParam: {
        type: 'string',
        default: '?skin=0',
      },
      widthField: {
        type: 'string',
        default: '100%',
      },
      heightField: {
        type: 'string',
        default: '500px',
      },
      borderField: {
        type: 'string',
        default: '0'
      },
      scrollField: {
        type: 'string',
        default: 'no'
      },
      classField: {
        type: 'string',
        default: 'iframe-class'
      },
    },
  
    edit: EditBlock,

    save( { attributes } ) {
      const { url, widgetParam, widthField, heightField, borderField, scrollField, classField } = attributes;
      
      return (
        <div>
        <iframe src={url + widgetParam} width={widthField} height={heightField} frameborder={borderField} scrolling={scrollField} class={classField} id="bed66_iFrame"></iframe>
        </div>
        );
    },

  });